import { useParams, Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './../../pages/product.module.css';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import ItemsTable from '../../components/quantila/items_table';
import UserDetails from '../../components/user_details';
import Navbar from '../../components/navbar';
import isLoggedIn from '../../utils/isLoggedIn';
import RFQDetails from '../../components/quantila/rfq_details';
import { convertEntitiesDeep } from '../../utils/convertEntities';

const RFQ = () => {
  const { id } = useParams();
  const url = `${process.env.REACT_APP_API}/admin/quantila/rfq/${id}`;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);
  const [rfq, setRFQ] = useState(); //Product details state
  const [user, setUser] = useState(); //Client details state
  const [isloading, setLoading] = useState(true); //Loading isloading toggle

  const token = sessionStorage.getItem('token');

  // Query to get product data
  useEffect(() => {
    //check if user is logged in
    isLoggedIn(navigate, dispatch, `/quantila/rfq/${id}`);

    let active = true;

    (async () => {
      const response = await axios(url, {
        headers: { authorization: `Bearer ${token}` },
      });
      if (active) {
        const data = convertEntitiesDeep(response.data);
        setRFQ(data);
        setUser(data.User);
        setItems(data.items);
        setLoading(false);
      }
    })();
    return () => {
      active = false;
      setRFQ(null);
      setUser(null);
      setItems(null);
    };
  }, [id]);

  //handle listing valitaion

  // -----------------------------------------------------------------------------

  return isloading ? (
    // Waiting data loading after async request...
    <>
      <Helmet>
        <title>Badgers SAS: Detailed request for quotation</title>
        <meta name='page' content='detailed request for quotation' />
      </Helmet>
      <div className='loading'>
        <img src='/img/loading.gif' alt='Loading' className='loading-img' />
      </div>
    </>
  ) : (
    <>
      <Helmet>
        <title>Badgers SAS: Detailed request for quotation</title>
        <meta name='page' content='detailed request for quotation' />
      </Helmet>
      <Navbar displayMob={true} />
      <div className={`${styles.background} container`}>
        <Toaster position='top-center' reverseOrder={false} />
        {/* ------------Navlinks----------- */}
        <div className=''>
          <Link className='page-links' to='/'>
            <FontAwesomeIcon icon='home' />{' '}
          </Link>
          <span className='link-span'>
            <FontAwesomeIcon icon='angle-right' />
          </span>
          <Link className='page-links' to='/quantila/rfqs'>
            RFQs{' '}
          </Link>
          <span className='link-span'>
            <FontAwesomeIcon icon='angle-right' />
          </span>
          <span className='link-span'>{rfq.title}</span>
        </div>
        {/* ----------------------- */}
        <div className='col-12 d-flex justify-content-center my-4'>
          <h4 className='h4'>
            {rfq.status < 1 ? 'RFQ DRAFT DETAILS' : 'RFQ DETAILS'}{' '}
            <FontAwesomeIcon icon='file-image' />
          </h4>
        </div>
        <div className={`${styles.card} row g-4 my-3 pb-3`}>
          <RFQDetails rfq={rfq} showQueriesButton />
          <UserDetails user={user} />
        </div>
        <ItemsTable items={items} />
      </div>
    </>
  );
};

export default RFQ;
